<template>
  <div>
    <div class="layout-header"
         :class="{'transparent':isTransparent}">
      <div class="header-logo">
        <img class="pic" :src="logoPicUrl" @click="toIndex"/>
      </div>
      <div @click="handleOpenMenu" class="header-menu-btn">
        <img class="icon" :src="menuBtnPicUrl" />
      </div>
    </div>

    <!--菜单-->
    <div class="layout-menu" :style="{'left': isShowMenu ? '0' : '-375px'}">
      <div class="layout-menu-header">
        <img class="logo" :src="logoPic" @click="toIndex"/>
        <img @click="handleCloseMenu" class="close" :src="closeBtnPic"/>
      </div>
      <div class="layout-menu-list">
        <a @click="pageJump('ManuscriptDownload')" class="menu-item">文稿下载</a>
        <a @click="pageJump('ImagesDownload')" class="menu-item">图片下载</a>
        <a @click="pageJump('VideosDownload')" class="menu-item">视频下载</a>
        <a @click="pageJump('MediaLogin')" class="menu-item">媒体登录</a>
        <a @click="pageJump('AboutUs')"  class="menu-item">关于我们</a>
      </div>
    </div>
    <!--/菜单-->
  </div>
</template>

<script>
export default {
  name: "LayoutHeader",
  props: {
    isTransparent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowMenu: false,
      logoPic: require('@/assets/MediaCenter/logo.png'),
      menuBtnPic: require('@/assets/MediaCenter/menu_btn.png'),
      logoBluePic: require('@/assets/MediaCenter/logo_blue.png'),
      menuBtnBluePic: require('@/assets/MediaCenter/menu_btn_blue.png'),
      closeBtnPic: require('@/assets/MediaCenter/close_btn.png')
    }
  },
  computed: {
    logoPicUrl() {
      return this.isTransparent ? this.logoPic : this.logoBluePic;
    },
    menuBtnPicUrl() {
      return this.isTransparent ? this.menuBtnPic : this.menuBtnBluePic;
    }
  },
  methods: {
    handleOpenMenu() {
      this.isShowMenu = true;
    },
    handleCloseMenu() {
      this.isShowMenu = false;
    },
    toIndex() {
      let currUrl = window.location.href;
      if(currUrl.indexOf("/Rccl.CustomPage/MediaCenter/Index")<0) {
        this.$router.push("/Rccl.CustomPage/MediaCenter/Index")
      }
      this.handleCloseMenu();
    },
    pageJump(name) {
      let currUrl = window.location.href;
      if(currUrl.indexOf(name)>=0 && currUrl.indexOf('redirectUrl')<0) {
        this.handleCloseMenu();
      } else {
        this.$router.push({name:name});
      }
    }
  }
}
</script>

<style lang="less" scoped>
.layout-header {
  display: flex;
  justify-content: space-between;
  height: 65px;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #E5E5E5;
  &.transparent {
    background-color: transparent;
    border-bottom: 1px solid transparent;
  }
  & .header-logo {
    height: 43px;
    width: 43px;
    margin-top: 11px;
    margin-left: 21.5px;
    & .pic {
      display: block;
      height: 100%;
    }
  }
  & .header-menu-btn {
    height: 20px;
    width: 26.5px;
    margin-top: 22.5px;
    margin-right: 20px;
    & .icon {
      display: block;
      height: 20px;
      width: 26.5px;
    }
    & .icon:active {
      opacity: .6;
    }
  }
  &.bg1 {
    background-color: #EBEBEB;
  }
}

/*菜单*/
.layout-menu {
  width: 375px;
  position: fixed;
  top: 0;
  left: -375px;
  height: 100vh;
  z-index: 90;
  transition: .2s;
  overflow-x: hidden;
  background-color: #00168b;
}
.layout-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
  padding: 0 21.5px;
  & .logo {
    height: 43px;
    width: 43px;
  }
  & .close {
    height: 20px;
    width: 20px;
  }
}
.layout-menu-list {
  width: 171px;
  margin: 44.5px auto 0;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
}
& .menu-item {
  display: block;
  position: relative;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  height: 60px;
  line-height: 60px;
  text-decoration: none;
  text-align: center;
  font-size: 1.16rem;
  font-family: PingFangSC-Regular, sans-serif;
  color: #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  & .menu-item:active {
    color: #dddddd;
  }
  & .link {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}
</style>
